export { default } from "./ForgotChallengeQuestions";



// WEBPACK FOOTER //
// ./src/banking/authentication/ForgotFlow/ForgotChallengeQuestions/index.js